// Style sheets
require("./scss/main.scss");

// Custom JavaScript
require("./js/header");
require("./js/single-studio");
require("./js/single-studio_promo-page");
require("./js/single-studio_quick-menu");
require("./js/single-studio_nav-bar");
require("./js/jobs/job-application-popup");
require("./js/save_utms_to_cookie");

//Modules
require("../modules/studio-search/shortcode-studio-search/shortcode-studio-search.js");

// Plugins
require("slick-carousel/slick/slick.js");
